import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import moment from "moment";

export default class MasterHargaJasaDetailHeader extends Component {
  render() {
    const { dataMD, onSetData, detail, errors, tempIdDoc } = this.props;
    return (
      <React.Fragment>
        <FlexView
          vAlignContent="center"
          style={{ justifyContent: "space-between" }}
        >
          <SimpleInput
            label="Kode Dokumen"
            readOnly
            containerclassname="width width-300px"
            value={tempIdDoc || detail?.kodeDokumen}
            id="input_id_dokumen"
          />
         <div className="width width-300px">
           <SimpleDate
            id="date_picker_tanggal_berlaku"
            name="tanggalBerlaku"
            label="Tanggal Berlaku"
            mandatory
            errorMessage={errors?.tanggalBerlaku}
            date={detail?.tanggalBerlaku}
            onChange={(value) =>
              onSetData("tanggalBerlaku", moment(value).format("DD-MM-YYYY"))
            }
          />
         </div>
        </FlexView>
        <FlexView
          vAlignContent="center"
          style={{ justifyContent: "space-between" }}
        >
          <SimpleDDL
            id="dropdown_main_dealer"
            box="search"
            label="Main Dealer"
            containerclassname="width width-300px"
            value={detail?.mainDealer}
            options={dataMD}
            mandatory
            errorMessage={errors?.mainDealer}
            onChange={(value) => onSetData("mainDealer", value)}
          />
          <SimpleDDL
            id="dropdown_kode_cabang"
            box="multiselect"
            label="Cabang Berlaku"
            containerclassname="width width-300px"
            value={detail?.kodeCabang}
            mandatory
            errorMessage={errors?.detailCabang}
            options={detail?.mainDealer?.kodeCabang}
            onChange={(value) => onSetData("kodeCabang", value)}
          />
        </FlexView>
        <SimpleTextArea
          id={"text_deskripsi"}
          name={"keterangan"}
          label="Keterangan"
          containerclassname="width width-300px"
          value={detail?.keterangan}
          onChange={({ target }) => onSetData(target.name, target.value)}
        />
      </React.Fragment>
    );
  }
}
